// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"6b12eacc","488":"f5182760"}[chunkId] + ".chunk.js";
};